//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'index',
  data () {
    return {
    }
  },
  methods: {
    GoToApplyPage: function () {
      this.$router.push({path: '/ApplyPage'})
    },
    GoToFindPage: function () {
      this.$router.push({path: '/FindDetail'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/index.vue